<template>
    <div class="star-rating">
        <label v-for="rating in ratings" :key="rating"
            :class="{
                'star-rating__star': true,
                'is-selected': value >= rating,
                'is-disabled': disabled
            }"
            @click="setRating(rating)"
            @mouseover="starOver(rating)"
            @mouseout="starOut">
                <input class="star-rating star-rating__checkbox" type="radio" :value="rating" :name="name" v-model="value" :disabled="disabled">★
        </label>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: 'sr01'
        },
        value: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        return {
            tempValue: null,
            ratings: [1, 2, 3, 4, 5]
        }
    },
    
    methods: {
        updateVal: function(v) {
            this.$emit('update:value', v)
        },
        
        starOver: function(index) {
            if(!this.disabled) {
                this.tempValue = this.value
                this.updateVal(index)
            }
        },
        
        starOut: function() {
            if(!this.disabled)
                this.updateVal(this.tempValue)
        },
        
        setRating: function(value) {
            if(!this.disabled) {
                this.tempValue = value
                this.updateVal(value)
            }
        }
    }
}
</script>

<style>
.star-rating__checkbox {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
}
.star-rating__star {
    display: inline-block;
    padding: 3px;
    vertical-align: middle;
    line-height: 1;
    font-size: 1.8em;
    color: #ABABAB;
    -webkit-transition: color .2s ease-out;
    transition: color .2s ease-out;
}
.star-rating__star:hover {
    cursor: pointer;
}
.star-rating__star.is-selected {
    color: #4C89CA;
}
.star-rating__star.is-disabled:hover {
    cursor: default;
}
</style>
